import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../common.service';
import {
  AzupayAccountInfo,
  AzupayOnboardingEligibility,
  AzupayOnboardingPrefill,
  OnboardingAzupayRequest,
} from '../model/azupay-onboarding.models';

@Injectable({ providedIn: 'root' })
export class AzupayOnboardingService {
  private readonly api = inject(ApiService);

  getAzupayOnboardingEligibility(tenantId: number): Observable<AzupayOnboardingEligibility> {
    const url = `Tenant/${tenantId}/azupay-onboarding-eligibility`;
    return this.api.get<AzupayOnboardingEligibility>(url);
  }

  confirmProcessOnboarding(tenantId: number): Observable<void> {
    const url = `Tenant/${tenantId}/confirm-process-onboarding`;
    return this.api.post(url, null);
  }

  getAzupayOnboardingPrefill(
    tenantId: number,
    tenantLegalId: number,
  ): Observable<AzupayOnboardingPrefill> {
    const url = `Tenant/${tenantId}/tenantLegals/${tenantLegalId}/azupay-onboarding-prefill`;
    return this.api.get<AzupayOnboardingPrefill>(url);
  }

  onboardAzupay(
    tenantId: number,
    tenantLegalId: number,
    request: OnboardingAzupayRequest,
  ): Observable<void> {
    const url = `Tenant/${tenantId}/tenantlegals/${tenantLegalId}/onboarding-azupay`;
    return this.api.post(url, request);
  }

  getAzupayAccountInfo(tenantId: number, tenantLegalId: number): Observable<AzupayAccountInfo> {
    const url = `Tenant/${tenantId}/tenantlegals/${tenantLegalId}/azupay-account-info`;
    return this.api.get<AzupayAccountInfo>(url);
  }
}
